import { render, staticRenderFns } from "./string-array.vue?vue&type=template&id=f0f6d1c2&scoped=true&"
import script from "./string-array.vue?vue&type=script&lang=ts&"
export * from "./string-array.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f6d1c2",
  null
  
)

export default component.exports